/* eslint-disable no-undef */
(function (root, factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory(
            require('backbone'),
            require('lodash'),
            require('jquery'),
            require('cookies-js'),
            require('./fp_persistent_image_model'),
            require('./fp_persistent_etag_model'),
        );
    } else if (typeof define === 'function' && define.amd) {
        define([
            'backbone',
            'lodash',
            'jquery',
            './fp_persistent_image_model',
            './fp_persistent_etag_model',
        ], function (
            Backbone,
            _,
            $,
            FpPersistentImageModel,
            FpPersistentEtagModel,
        ) {
            return factory(
                Backbone,
                _,
                $,
                {
                    get: $.cookie,
                    set: $.cookie,
                },
                FpPersistentImageModel,
                FpPersistentEtagModel,
            );
        });
    }
})(this, function (
    Backbone,
    _,
    $,
    Cookies,
    FpPersistentImageModel,
    FpPersistentEtagModel,
) {
    'use strict';

    var COOKIE = 'ebfp',
        /**
         * Model to store a value to traidition HTTP Cookies.
         */
        FpPersistentBasicModel = Backbone.Model.extend({
            getValue: function () {
                return $.Deferred().resolve(Cookies.get(COOKIE)).promise();
            },
            setValue: function (value) {
                Cookies.set(COOKIE, value, { path: '/', expires: 100 });
                return $.Deferred().resolve(true).promise();
            },
        }),
        /**
         * Model to store a value to HTML5 Local Storage.
         */
        FpPersistentLocalModel = Backbone.Model.extend({
            getValue: function () {
                var value;

                try {
                    value = window.localStorage[COOKIE];
                } catch (e) {
                    // swallow
                }

                return $.Deferred().resolve(value).promise();
            },
            setValue: function (value) {
                var success = true;

                try {
                    window.localStorage[COOKIE] = value;
                } catch (e) {
                    success = false;
                }

                return $.Deferred().resolve(success).promise();
            },
        }),
        /**
         * Model to store a value to HTML5 Session Storage.
         */
        FpPersistentSessionModel = Backbone.Model.extend({
            getValue: function () {
                var value;

                try {
                    value = window.sessionStorage[COOKIE];
                } catch (e) {
                    // swallow
                }

                return $.Deferred().resolve(value).promise();
            },
            setValue: function (value) {
                var success = true;

                try {
                    window.sessionStorage[COOKIE] = value;
                } catch (e) {
                    success = false;
                }

                return $.Deferred().resolve(success).promise();
            },
        });

    /**
     * In-house implementation of of persistent cookies.
     *
     * A persistent cookie is a storage mechanism to keep an arbitrary
     * value with a user's browser that is difficult to remove. It does
     * this by keeping the value in many client-side storage locations.
     * If any of the storage locatons are wiped, the value can be regenerated
     * from the other locations.
     *
     * Each of these locations is implemented as a plugin that implemnents
     * two methods: getValue() and setValue(value) to read and write the value
     * to their respective locations.
     */
    return Backbone.Model.extend({
        initialize: function () {
            this.models = [
                new FpPersistentBasicModel(),
                new FpPersistentLocalModel(),
                new FpPersistentSessionModel(),
                new FpPersistentImageModel(),
                new FpPersistentEtagModel(),
            ];
        },

        /**
         * Get the raw values from each location.
         */
        getValues: function () {
            var $deferred = new $.Deferred(),
                deferredValues = this.models.map(function (model) {
                    return model.getValue();
                });

            $.when.apply(this, deferredValues).done(function () {
                $deferred.resolve(arguments);
            });
            return $deferred.promise();
        },

        /**
         * Parse the raw values for a cannonical value and tampering.
         *
         * We also calculate the dirty models here. These denote cache
         * location where the values are missing, wiped, or tampered, and
         * need to be repopulated.
         */
        resolveValues: function (values) {
            var $deferred = new $.Deferred(),
                uniqValues = _.uniq(_.compact(values)),
                tampered = uniqValues.length > 1,
                dirtyModels,
                resolved;

            if (tampered) {
                dirtyModels = this.models;
            } else {
                dirtyModels = _.filter(this.models, function (model, i) {
                    return !values[i];
                });
            }

            resolved = {
                dirtyModels: dirtyModels,
                tampered: tampered,
                value: '',
            };

            // Find the cannonical value from any cache. If it can't find
            // a valid one, ask the server to generate a new one.
            // The resolution rules here are hand-tuned. Since image and
            // etag caches are harder to inject into, those values are
            // trusted heavily.
            if (uniqValues.length === 1) {
                resolved.value = uniqValues[0];
            } else if (values[4]) {
                resolved.value = values[4];
            } else if (values[3]) {
                resolved.value = values[3];
            }

            if (resolved.value) {
                $deferred.resolve(resolved);
            } else {
                $.getJSON('/ajax/fp').done(function (data) {
                    resolved.value = data.hash;
                    $deferred.resolve(resolved);
                });
            }

            return $deferred.promise();
        },

        /**
         * Parse the raw values for a cannonical value and tampering.
         */
        setValues: function (resolved) {
            var $deferred = new $.Deferred(),
                deferredSuccesses = resolved.dirtyModels.map(function (model) {
                    return model.setValue(resolved.value);
                });

            $.when.apply(this, deferredSuccesses).done(function () {
                $deferred.resolve({
                    success: _.every(arguments),
                    tampered: resolved.tampered,
                    value: resolved.value,
                });
            });

            return $deferred.promise();
        },

        /**
         * Main has generation function.
         */
        getHash: function () {
            var $deferred = new $.Deferred();

            // We have to do this ugliness because older jQuery Promises
            // are broken for long-chains.
            this.getValues().done(
                function (values) {
                    this.resolveValues(values).done(
                        function (resolved) {
                            this.setValues(resolved).done(function (results) {
                                $deferred.resolve(results);
                            });
                        }.bind(this),
                    );
                }.bind(this),
            );

            return $deferred.promise();
        },
    });
});
